<div class="filter-list" [class.filter-list--events-compact]="compact">
  <!-- Event Name -->
  <div class="filter-list__group">
    <h2 class="filter-list__group-header">Event Name (optional)</h2>
    <div class="filter-list__group-content">
      <input #eventNameField id="eventName" type="" class="landing-page__field landing-page__query-field"
             [(ngModel)]="aviationEventFilter.name" (input)="onEventNameChange($event)"
             aria-label="EventName"  autocomplete="off" autocorrect="off">
    </div>
  </div>

  <!-- Date Range -->
  <div class="filter-list__group">
    <h2 class="filter-list__group-header">Date Range</h2>
    <div class="filter-list__group-content">
      <!-- Start date -->
      <mat-form-field class="event-date-picker">
        <input matInput [matDatepicker]="startDate" placeholder="Start" [(ngModel)]="aviationEventFilter.startDate" (dateChange)="onChangeDate('start', $event)" width="25px">
        <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
        <mat-datepicker #startDate></mat-datepicker>
      </mat-form-field>
      <span>&nbsp;&nbsp;</span>
      <!-- End date -->
      <mat-form-field class="event-date-picker">
        <input matInput [matDatepicker]="endDate" placeholder="End" [(ngModel)]="aviationEventFilter.endDate" (dateChange)="onChangeDate('end', $event)" width="25px">
        <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
        <mat-datepicker #endDate></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
</div>

<div class="filter-list" [class.filter-list--events-compact]="compact">
  <!-- Community Events -->
  <div class="filter-list__group">
    <h2 class="filter-list__group-header">Community Events</h2>
    <div class="filter-list__group-buttonbar">
      <span class="filter-list__group-button" (click)="onSelectAllCommunityEvents()">Select All</span> | <span class="filter-list__group-button" (click)="onClearAllCommunityEvents()">Clear All</span>
    </div>
    <div class="filter-list__group-content">
      <div class="filter">
      <mat-checkbox [(ngModel)]="aviationEventFilter.airshow" (change)="onChangeInPersonEvent(aviationEventFilter)" aria-label="Airshow" class="filter__checkbox">
        <div class="filter__header">
          <span class="filter__label">Airshow</span>
        </div>
      </mat-checkbox>
      </div>

      <div class="filter-indent">
        <mat-checkbox [(ngModel)]="aviationEventFilter.airshowwithmilitarydemonstrationteam" (change)="onChangeInPersonEvent(aviationEventFilter)" aria-label="Airshow with Military Demonstration Team" class="filter__checkbox">
          <div class="filter__header">
            <span class="filter__label">Airshow w/ Military Demonstration Team</span>
          </div>
        </mat-checkbox>
      </div>

      <div class="filter">
      <mat-checkbox [(ngModel)]="aviationEventFilter.flyin" (change)="onChangeInPersonEvent(aviationEventFilter)" aria-label="Fly-In" class="filter__checkbox">
        <div class="filter__header">
          <span class="filter__label">Fly-In</span>
        </div>
      </mat-checkbox>
      </div>

      <div class="filter">
      <mat-checkbox  [(ngModel)]="aviationEventFilter.flyout" (change)="onChangeInPersonEvent(aviationEventFilter)" aria-label="Fly-Out" class="filter__checkbox">
        <div class="filter__header">
          <span class="filter__label">Fly-Out</span>
        </div>
      </mat-checkbox>
      </div>

      <div class="filter">
        <mat-checkbox #checkbox [(ngModel)]="aviationEventFilter.pancakeBreakfast" (change)="onChangeInPersonEvent(aviationEventFilter)" aria-label="Pancake Breakfast" class="filter__checkbox">
          <div class="filter__header">
            <span class="filter__label">Pancake Breakfast</span>
          </div>
        </mat-checkbox>
      </div>

      <div class="filter">
        <mat-checkbox #checkbox [(ngModel)]="aviationEventFilter.socialGathering" (change)="onChangeInPersonEvent(aviationEventFilter)" aria-label="Social Gathering" class="filter__checkbox">
          <div class="filter__header">
            <span class="filter__label">Social Gathering</span>
          </div>
        </mat-checkbox>
      </div>

      <div class="filter">
        <mat-checkbox #checkbox [(ngModel)]="aviationEventFilter.openhouse" (change)="onChangeInPersonEvent(aviationEventFilter)" aria-label="Openhouse" class="filter__checkbox">
          <div class="filter__header">
            <span class="filter__label">Openhouse</span>
          </div>
        </mat-checkbox>
      </div>

      <div class="filter">
        <mat-checkbox #checkbox [(ngModel)]="aviationEventFilter.pokerRun" (change)="onChangeInPersonEvent(aviationEventFilter)" aria-label="Poker Run" class="filter__checkbox">
          <div class="filter__header">
            <span class="filter__label">Poker Run</span>
          </div>
        </mat-checkbox>
      </div>

      <div class="filter">
        <mat-checkbox #checkbox [(ngModel)]="aviationEventFilter.aviationCommunityDay" (change)="onChangeInPersonEvent(aviationEventFilter)" aria-label="Aviation Community Day" class="filter__checkbox">
          <div class="filter__header">
            <span class="filter__label">Aviation Community Day</span>
          </div>
        </mat-checkbox>
      </div>

      <div class="filter">
        <mat-checkbox #checkbox [(ngModel)]="aviationEventFilter.wingsAndWheels" (change)="onChangeInPersonEvent(aviationEventFilter)" aria-label="Wings And Wheels Event" class="filter__checkbox">
          <div class="filter__header">
            <span class="filter__label">Wings And Wheels Event</span>
          </div>
        </mat-checkbox>
      </div>

      <div class="filter">
        <mat-checkbox #checkbox [(ngModel)]="aviationEventFilter.aircraftDisplayRides" (change)="onChangeInPersonEvent(aviationEventFilter)" aria-label="Aircraft Display/Rides" class="filter__checkbox">
          <div class="filter__header">
            <span class="filter__label">Aircraft Display/Rides</span>
          </div>
        </mat-checkbox>
      </div>

    </div>
  </div>

  <!-- Seminars/Conferences/Workshops -->
  <div class="filter-list__group">
    <h2 class="filter-list__group-header">Seminars/Conferences/Workshops</h2>
    <div class="filter-list__group-buttonbar">
      <span class="filter-list__group-button" (click)="onSelectAllSeminars()">Select All</span> | <span class="filter-list__group-button" (click)="onClearAllSeminars()">Clear All</span>
    </div>
    <div class="filter-list__group-content">
      <div class="filter">
        <mat-checkbox [(ngModel)]="aviationEventFilter.aopaRustyPilots" (change)="onChangeInPersonEvent(aviationEventFilter)" aria-label="AOPA Rusty Pilots" class="filter__checkbox">
          <div class="filter__header">
            <span class="filter__label">AOPA Rusty Pilots</span>
          </div>
        </mat-checkbox>
      </div>

      <div class="filter">
        <mat-checkbox [(ngModel)]="aviationEventFilter.aopaFlyingClub" (change)="onChangeInPersonEvent(aviationEventFilter)" aria-label="AOPA Flying Clubs" class="filter__checkbox">
          <div class="filter__header">
            <span class="filter__label">AOPA Flying Clubs</span>
          </div>
        </mat-checkbox>
      </div>

      <div class="filter">
        <mat-checkbox #checkbox [(ngModel)]="aviationEventFilter.aopaBacktoYourRoots" (change)="onChangeInPersonEvent(aviationEventFilter)" aria-label="AOPA Back to Your Roots" class="filter__checkbox">
          <div class="filter__header">
            <span class="filter__label">AOPA Back to Your Roots</span>
          </div>
        </mat-checkbox>
      </div>

      <div class="filter">
        <mat-checkbox  [(ngModel)]="aviationEventFilter.safetySeminar" (change)="onChangeInPersonEvent(aviationEventFilter)" aria-label="Safety Seminar" class="filter__checkbox">
          <div class="filter__header">
            <span class="filter__label">Safety Seminar</span>
          </div>
        </mat-checkbox>
      </div>

      <div class="filter">
        <mat-checkbox #checkbox [(ngModel)]="aviationEventFilter.conference" (change)="onChangeInPersonEvent(aviationEventFilter)" aria-label="Conference" class="filter__checkbox">
          <div class="filter__header">
            <span class="filter__label">Conference</span>
          </div>
        </mat-checkbox>
      </div>

      <div class="filter">
        <mat-checkbox #checkbox [(ngModel)]="aviationEventFilter.workshop" (change)="onChangeInPersonEvent(aviationEventFilter)" aria-label="Workshop" class="filter__checkbox">
          <div class="filter__header">
            <span class="filter__label">Workshop</span>
          </div>
        </mat-checkbox>
      </div>

    </div>
  </div>

  <!-- Online Events -->
  <div class="filter-list__group">
    <h2 class="filter-list__group-header">Event Format</h2>
    <div class="filter-list__group-content">
      <div class="filter">
        <mat-checkbox #checkbox [(ngModel)]="aviationEventFilter.formatInPerson" (change)="onChangeFormat('formatInPerson')" aria-label="In-Person" class="filter__checkbox">
          <div class="filter__header">
            <span class="filter__label">In-Person</span>
          </div>
        </mat-checkbox>
      </div>

      <div class="filter">
        <mat-checkbox #checkbox [(ngModel)]="aviationEventFilter.formatOnline" (change)="onChangeFormat('formatOnline')" aria-label="Online" class="filter__checkbox">
          <div class="filter__header">
            <span class="filter__label">Online</span>
          </div>
        </mat-checkbox>
      </div>
    </div>
  </div>

</div>
